<script>
  import CursoEvento from './AcessoTiposDetalhamentoCursoEvento.vue';
  import Doacao from './AcessoTiposDetalhamentoDoacao.vue';
  import linguagens from '~js/linguagens';
  import solCursoEventoDoacaoTranslate from '~js/solCursoEventoDoacaoTranslate';

  export default {
    components: { CursoEvento, Doacao },
    props: {
      acessoObjeto: {},
    },
    data() {
      return {
        linguagens: linguagens,
        linguagensDisponiveis: [],
        linguagemSelecionada: 'pt-Br',
        solCursoEventoDoacaoTranslate: solCursoEventoDoacaoTranslate,
        labelsLinguagemSelecionada: {},
        labelsDadosLinguagemSelecionada: {},

        configuracao: this.$storage.configuracao(),
        imagemCover: '',
        rotaAnterior: '',
        rotaInscricao: '',
        textoBotao: '',
        classeBotao: '',
        cursosEventosObj: {},
        doacaoObj: {},

        cursoEvento: false,
        servico: false,
        doacoes: false,
      }
    },
    methods: {
      setarLinguagemSelecionada(simbolo){
        this.linguagemSelecionada = simbolo;
        this.labelsLinguagemSelecionada = this.solCursoEventoDoacaoTranslate.filter(l => l.simbolo == simbolo)[0];
        
        if (this.acessoObjeto.doacao){
            this.labelsDadosLinguagemSelecionada = this.acessoObjeto.doacao.doacaoTraducoes.filter(l => l.idLinguagem == this.labelsLinguagemSelecionada.id)[0];
        } 

        if (this.acessoObjeto.turma){
            this.labelsDadosLinguagemSelecionada = this.acessoObjeto.turma.turmaTraducoes.filter(l => l.idLinguagem == this.labelsLinguagemSelecionada.id)[0];
        } 

        this.configuraTipo(true);
      },
      mostraLinguagens(){
        this.linguagensDisponiveis = [];

        this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'pt-Br')[0])

        if (this.acessoObjeto.turma){
            if (this.acessoObjeto.turma.traduzirIngles)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'en')[0])

            if (this.acessoObjeto.turma.traduzirEspanhol)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'es')[0])

            if (this.acessoObjeto.turma.traduzirFrances)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'fr')[0])

            if (this.acessoObjeto.turma.traduzirItaliano)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'it')[0])
        }

        if (this.acessoObjeto.doacao){
            if (this.acessoObjeto.doacao.traduzirIngles)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'en')[0])

            if (this.acessoObjeto.doacao.traduzirEspanhol)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'es')[0])

            if (this.acessoObjeto.doacao.traduzirFrances)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'fr')[0])

            if (this.acessoObjeto.doacao.traduzirItaliano)
                this.linguagensDisponiveis.push(this.linguagens.filter(l => l.simbolo == 'it')[0])
        }
      },
      configuraTipo(mudandoLinguagem) {
        switch (this.$route.name) {
          case 'acessos.cursos-detalhamento':
            if (!mudandoLinguagem)
                this.imagemCover = 'img/acesso/atalhos/curso_cover.png';
            this.rotaAnterior = 'acessos.cursos';
            this.rotaInscricao = 'acessos.cursos-inscricao';
            this.textoBotao = this.labelsInscrever;
            this.classeBotao = 'fa fa-file-text-o';
            this.cursoEvento = true;
            break;
          case 'acessos.eventos-detalhamento':
            if (!mudandoLinguagem)
                this.imagemCover = 'img/acesso/atalhos/evento_cover.png';
            this.rotaAnterior = 'acessos.eventos';
            this.rotaInscricao = 'acessos.eventos-inscricao';
            this.textoBotao = this.labelsInscrever;
            this.classeBotao = 'fa fa-file-text-o';
            this.cursoEvento = true;
            break;
          case 'acessos.servicos-detalhamento':
            if (!mudandoLinguagem)
                this.imagemCover = 'img/acesso/atalhos/evento_cover.png';
            this.rotaAnterior = 'acessos.servicos';
            this.servico = true;
            break;
          case 'acessos.doacoes-detalhamento':
            if (!mudandoLinguagem)
                this.imagemCover = 'img/acesso/atalhos/doacao_cover.png';
            this.rotaAnterior = 'acessos.doacoes';
            this.rotaInscricao = 'acessos.doacoes-doar';
            this.classeBotao = 'fa fa-money';
            this.textoBotao = this.labelsDoar;
            this.doacoes = true;
            break;
          default:
            this.$router.push('/acessos');
        }

        let a = this.acessoObjeto;
      },      
    },
    computed: {
        labelsInscrever(){
            return this.labelsLinguagemSelecionada.labels.inscrever;
        },
        labelsDoar(){
            return this.labelsLinguagemSelecionada.labels.doar;
        },

        retornarTextoInscricao() {
            if (this.acessoObjeto.turma) {
                if (this.acessoObjeto.turma.naoMostrarPeriodoInscricao)
                    return '';

                return this.labelsLinguagemSelecionada.labels.inscricaoCase + ': ' +
                    this.acessoObjeto.turma.dataInicioInscTurma +
                    ' à ' +
                    this.acessoObjeto.turma.dataLimiteInscTurma;
            }
        else
          return '';      
      }
    },
    mounted() {
        
    },
    created() {
      this.mostraLinguagens();
      this.setarLinguagemSelecionada(this.linguagemSelecionada);
      this.configuraTipo(false);

      if (this.acessoObjeto.solicitacaoCursoEventos) {
        this.cursosEventosObj = this.acessoObjeto.solicitacaoCursoEventos[0];

        if (this.acessoObjeto.turma) {
          if (this.acessoObjeto.turma.urlImagemPerfil) {
            this.imagemCover = this.acessoObjeto.turma.urlImagemPerfil;
          }
        }
      }

      if (this.acessoObjeto.solicitacaoDoacao) {
        this.doacaoObj = this.acessoObjeto.solicitacaoDoacao[0];
      }

      if (this.acessoObjeto.doacao) {
        this.acessoObjeto.descricao = this.acessoObjeto.doacao.descricao; 
        this.acessoObjeto.resumo = this.acessoObjeto.doacao.resumo; 
        this.doacaoObj = this.acessoObjeto.doacao;

        if (this.acessoObjeto.doacao) {
          if (this.acessoObjeto.doacao.urlImagemPerfil) {
            this.imagemCover = this.acessoObjeto.doacao.urlImagemPerfil;
          }
        }
      }
    }
  }
</script>

<template>
  <div>
    <div>
      <article class="well listing-item">
        <div class="media-left listing-item__logo">
          <img class="media-object profile__img-company" :src="imagemCover">
        </div>

        <div class="media-body-local">
          <div class="media-heading listing-item__title">
            {{ labelsDadosLinguagemSelecionada.descricao }}
          </div>
          <div class="listing-item__date">
            {{ retornarTextoInscricao }}
          </div>
          <div class="listing-item__desc">
            {{ labelsDadosLinguagemSelecionada.resumo }}
          </div>
        </div>

        <div class="row" v-if="linguagensDisponiveis.length > 1" style="text-align: center;">
            <label class="control-label">{{ this.labelsLinguagemSelecionada.labels.escolhaIdioma }}</label>
           <div class="col-sm-12">
              <table class="table" style="width: auto;margin-bottom: 0px;" align='center'>
                  <tbody>
                      <tr>
                          <td style="text-align: center;width: 64px;" v-for="lingua in linguagensDisponiveis">
                              <a @click="setarLinguagemSelecionada(lingua.simbolo)">
                                  <img :src="lingua.imagem" :alt="lingua.simbolo" style="width:64px;height:64px;" :v-tooltip="lingua.simbolo"
                                       :class="{'LinguagemNaoSelecionada': linguagemSelecionada != lingua.simbolo}">
                              </a>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </div>

        <div class="hr-line-dashed margin-top-20"></div>

        <div class="row">
          <dl class="col-xs-0 col-sm-4">
          </dl>
          <dl class="col-xs-6 col-sm-2">
              <router-link class="btn btn-info"
                           :to="{ name: rotaAnterior }"
                           style="width:125px;"
                           active-class="">
                  <i class="fa fa-arrow-left"></i>  {{ this.labelsLinguagemSelecionada.labels.voltar }}
              </router-link>
          </dl>
          <dl class="col-xs-5 col-sm-2">
            <router-link class="btn btn-success"
                         :to="{ name: rotaInscricao, params: { linguagemSelecionada: linguagemSelecionada  } }"
                         style="width:125px;"
                         active-class="">
              <i :class="classeBotao"></i>  {{ textoBotao }}
            </router-link>
          </dl>
          <dl class="col-xs-0 col-sm-4">
          </dl>
        </div>

        <div class="hr-line-dashed" style="margin-top: 0px;"></div>

        <curso-evento :acessoObjeto="cursosEventosObj" :turma="acessoObjeto.turma" :labelsDadosLinguagemSelecionada.sync="labelsDadosLinguagemSelecionada"  :labelsLinguagemSelecionada.sync="labelsLinguagemSelecionada" v-if="cursoEvento && cursosEventosObj">

        </curso-evento>

        <doacao :acessoObjeto="doacaoObj" :labelsLinguagemSelecionada.sync="labelsLinguagemSelecionada" :labelsDadosLinguagemSelecionada.sync="labelsDadosLinguagemSelecionada" v-if="doacoes && doacaoObj">

        </doacao>


      </article>

    </div>
  </div>
</template>

<style scoped>
  .listing-item {
    margin: 0 auto 20px;
    display: block;
    width: 85%;
  }

  .listing-item__date {
    color: rgba(62, 62, 62, 0.3);
    font-weight: bold;
    margin-bottom: 5px;
    font-size: 14px;
    white-space: nowrap;
  }

  .listing-item__desc {
    text-overflow: ellipsis;
    margin-top: 8px;
    padding-right: 21px;
    line-height: 24px;
    margin-bottom: 6px;
    overflow: hidden;
    max-width: 700px;
    word-break: break-word;
  }

  .media-left {
    padding-right: 10px;
  }

  @media (min-width: 768px) {
    .media-body-local, .media-left {
      display: table-cell;
      vertical-align: top;
    }
  }

  @media (max-width: 768px) {

    .media-left {
      display: table-cell;
      vertical-align: top;
    }

    .media-body-local {
      margin-top: 10px;
    }
  }

  .listing-item__title {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 8px;
  }

  .listing-item__logo {
    vertical-align: middle;
    min-width: 150px;
    width: 150px;
    text-align: center;
    position: relative;
  }

  .listing-item__logo .media-object:not(.profile__img) {
    max-width: 125px;
    max-height: 125px;
    margin-right: 15px;
    display: inline-block;
  }

  .profile__img-company {
    border-radius: 6px;
    width: 115px;
    height: 115px;
  }

  .well {
    min-height: 20px;
    padding: 19px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
  }

  .well {
    border-radius: 6px;
  }

  .listing-item {
    min-width: 310px;
    min-height: 104px;
    background-color: #fff;
    box-shadow: none;
    -webkit-transition: box-shadow 0.2s ease-in;
    -moz-transition: box-shadow 0.2s ease-in;
    -o-transition: box-shadow 0.2s ease-in;
    transition: box-shadow 0.2s ease-in;
  }

  .LinguagemNaoSelecionada {
    opacity: 0.3;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/acessos/componentes/compartilhado/AcessoTiposDetalhamento.vue